import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardMetricDetailStore } from "../stores/metric-detail.store";
import { dashboardOrgDetailStore } from "../stores/org-detail.store";
import { buildDashboardScopePayload } from "../utils/dashboard-request-scope";
import { resolveSelectedReportingPeriod } from "../utils/reporting-years";

export const loadMetricDetailForPanel = async (key) => {
  const store = dashboardMetricDetailStore;
  const panel = store.getPanel(key);
  if (!panel || !panel.pivot) return;

  const { years, frameworks, categories } = dashboardFiltersStore.filters;
  const { disclosureId, year } = panel.pivot;
  const { drillOrgIds, statuses, search, page, pageSize } = panel;
  const reportingPeriod = resolveSelectedReportingPeriod(
    years,
    dashboardFiltersStore.available.reportingYears,
  );

  panel.setLoading(true);
  try {
    const data = await dashboardService.getMetricDetail({
      years,
      ...(reportingPeriod || {}),
      frameworks,
      categories,
      ...buildDashboardScopePayload({
        filters: dashboardFiltersStore.filters,
        orgTree: dashboardFiltersStore.available.orgTree,
      }),
      disclosureId,
      year,
      drillOrgIds,
      statuses,
      search,
      page,
      pageSize,
    });
    runInAction(() => {
      if (store.isExpanded(key)) {
        panel.setResult(data);
      }
    });
  } finally {
    panel.setLoading(false);
  }
};

export const loadAllMetricDetails = async () => {
  const store = dashboardMetricDetailStore;
  const keys = Array.from(store.expandedKeys);
  await Promise.all(keys.map((key) => loadMetricDetailForPanel(key)));
};

export const loadOrgDetailForPanel = async (key) => {
  const store = dashboardOrgDetailStore;
  const panel = store.getPanel(key);
  if (!panel || !panel.pivot) return;

  const { years, frameworks, categories } = dashboardFiltersStore.filters;
  const { orgId } = panel.pivot;
  const {
    drillYears,
    drillFrameworks,
    drillCategories,
    statuses,
    search,
    page,
    pageSize,
  } = panel;

  panel.setLoading(true);
  const reportingPeriod = resolveSelectedReportingPeriod(
    years,
    dashboardFiltersStore.available.reportingYears,
  );

  try {
    const data = await dashboardService.getOrgDetail({
      years,
      ...(reportingPeriod || {}),
      frameworks,
      categories,
      ...buildDashboardScopePayload({
        filters: dashboardFiltersStore.filters,
        orgTree: dashboardFiltersStore.available.orgTree,
      }),
      orgId,
      drillYears,
      drillFrameworks,
      drillCategories,
      statuses,
      search,
      page,
      pageSize,
    });
    runInAction(() => {
      if (store.isExpanded(key)) {
        panel.setResult(data);
      }
    });
  } finally {
    panel.setLoading(false);
  }
};

export const loadAllOrgDetails = async () => {
  const store = dashboardOrgDetailStore;
  const keys = Array.from(store.expandedKeys);
  await Promise.all(keys.map((key) => loadOrgDetailForPanel(key)));
};
